import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { useLanguage } from '../context/LanguageContext';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export const PaymentEmailHistoryDialog = ({ payment, onClose, onSend }) => {
  const { language } = useLanguage();
  const L = (el, en) => (language === 'el' ? el : en);
  const [rows, setRows] = useState(null);
  useEffect(() => {
    if (!payment) return;
    setRows(null);
    axios.get(`${API}/apartment-payments/${payment.payment_id}/email-history`).then((r) => setRows(r.data)).catch(() => setRows([]));
  }, [payment]);
  return (
    <Dialog open={!!payment} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="rounded-none max-w-2xl" data-testid="payment-email-history-dialog">
        <DialogHeader><DialogTitle>{L('Ιστορικό αποστολής απόδειξης', 'Receipt email history')} {payment?.receipt_number || ''}</DialogTitle></DialogHeader>
        {rows && !rows.length && <p className="text-sm text-zinc-500" data-testid="payment-email-history-empty">{L('Η απόδειξη δεν έχει σταλεί ακόμη.', 'This receipt has not been sent yet.')}</p>}
        {rows?.length > 0 && (
          <table className="w-full text-xs" data-testid="payment-email-history-table">
            <thead><tr className="bg-zinc-50 text-zinc-600">{[L('Ημερομηνία', 'Date'), L('Παραλήπτης', 'Recipient'), L('Κατάσταση', 'Status'), L('Από', 'By')].map((h) => <th key={h} className="px-2 py-1.5 text-left font-semibold">{h}</th>)}</tr></thead>
            <tbody>{rows.map((r) => (
              <tr key={r.log_id} className="border-t border-zinc-100">
                <td className="px-2 py-1.5">{new Date(r.sent_at).toLocaleString('el-GR')}</td>
                <td className="px-2 py-1.5">{r.to_email}{r.cc ? ` (cc ${r.cc})` : ''}</td>
                <td className="px-2 py-1.5">{r.status === 'sent' ? <span className="text-emerald-700 font-semibold">{L('Στάλθηκε', 'Sent')}</span> : <span className="text-red-700 font-semibold" title={r.error}>{L('Απέτυχε', 'Failed')}{r.error ? ` — ${r.error.slice(0, 80)}` : ''}</span>}</td>
                <td className="px-2 py-1.5">{r.sent_by}</td>
              </tr>))}</tbody>
          </table>)}
        <div className="flex justify-end"><Button className="rounded-none" onClick={() => { const p = payment; onClose(); onSend(p); }} data-testid="payment-email-resend-btn">{rows?.length ? L('Επαναποστολή απόδειξης', 'Resend receipt') : L('Αποστολή απόδειξης', 'Send receipt')}</Button></div>
      </DialogContent>
    </Dialog>
  );
};

export default PaymentEmailHistoryDialog;
